export const type = 'form.template';
